var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3235 0.875C10.5996 0.875 10.8235 1.09888 10.8235 1.375V3.375C10.8235 3.65112 10.5996 3.875 10.3235 3.875H7.53052C6.4259 3.875 5.53052 4.77051 5.53052 5.875V8.375H9.51379C9.85828 8.375 10.0996 8.71533 9.9856 9.04028L9.28491 11.0403C9.21472 11.2407 9.02539 11.375 8.81299 11.375H5.53052V19.625C5.53052 19.9011 5.30664 20.125 5.03052 20.125H3.03052C2.75439 20.125 2.53052 19.9011 2.53052 19.625V11.375H0.71875C0.442627 11.375 0.21875 11.1511 0.21875 10.875V8.875C0.21875 8.59888 0.442627 8.375 0.71875 8.375H2.53052V5.875C2.53052 3.11353 4.76904 0.875 7.53052 0.875H10.3235Z",
    fill: "#B1924C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1dc59e91cfde7e655daff55e59c20f85.svg";
export { ForwardRef as ReactComponent };